import AddNew from 'Components/Atoms/ExpandableItems/AddNew';
import Grid from 'Components/Atoms/Grid/Grid';
import Title from 'Components/Atoms/Title/Title';
import EditButton from 'Components/Molecules/EditButton/EditButton';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { convertDateToYear } from 'Services/Date/Date';
import { createCandidateValues, saveCandidateValues } from 'Store/Candidate/Actions';
import { CandidateId } from 'Store/Candidate/PropTypes';
import { getCandidate, getCandidateValuesFromCandidateId } from 'Store/Candidate/Selectors';
import { CANDIDATE_PREDEFINED, FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import containerStyles from './../../Organisms/LayoutContainer/LayoutContainer.module.sass';
import styles from './Educations.module.sass';

const calculateTimeDifference = (date1: any, date2: any) => {
    date1 = new Date(date1);
    date2 = !date2 ? new Date() : new Date(date2);

    let output = '';
    let monthDiff = date2.getMonth() - date1.getMonth() + 12 * (date2.getFullYear() - date1.getFullYear());
    monthDiff += date2.getDate() > 15 ? 1 : 0;

    const years = Math.floor(monthDiff /  12);
    const months = monthDiff % 12;
    if (years > 0) {
        output += years + ' jaar';
    }

    if (years > 0 && months > 0) {
        output += ' en ';
    }

    if (months > 0) {
        output += months + (months == 1 ? ' maand' : ' maanden');
    }

    if (years <= 0 && months <= 0) {
        output = "0 maanden";
    }

    return output;
}

const Educations = ({ entity_id, candidate, values, ...props}: WorkExperiencesProps) => {
    const [state, setState] = useState({ isEdit: false });

    const [data, setData] = useState(values?.[CANDIDATE_PREDEFINED.EDUCATION]?.value || []);
    useEffect(() => {
        setData(values?.[CANDIDATE_PREDEFINED.EDUCATION]?.value || []);
    }, [values]);

    const emptyDataObject = {
        education_institute: '',
        education: '',
        achieved: false,
        start_date: '',
        end_date: ''
    }

    const handleAddEducation = () => setData([...data, emptyDataObject]);

    const handleDeleteEducation = (idx: number) => {
        const tempData = [...data]?.filter((_, tempIdx: number) => tempIdx != idx);
        
        setData(tempData);
    }

    const handleCancel = () => setData(values?.[CANDIDATE_PREDEFINED.EDUCATION]?.value || []);

    const handleSave = () => {
        data.sort((a, b) => (a.start_date < b.start_date) ? 1 : -1);

        if (values?.[CANDIDATE_PREDEFINED.EDUCATION]?.value_id) {
            props.saveCandidateValues(entity_id, {[values?.[CANDIDATE_PREDEFINED.EDUCATION]?.value_id]: data});
        } else {
            props.createCandidateValues(entity_id, {[CANDIDATE_PREDEFINED.EDUCATION]: data});
        }

        setState((state) => ({
            ...state,
            isEdit: false
        }));
    };

    return <div className={containerStyles['layoutcontainer']} style={{width: '100%'}}>
        <Grid
            position='between'
            align='center'
            axis='horizontal'
        >
            <Title weight='semibold'>Opleidingen</Title>
            
            <EditButton
                variant='button'
                isEdit={state.isEdit}
                onChange={(value) => setState({
                    ...state,
                    isEdit: value
                })}
                onSave={handleSave}
            />
        </Grid>

        { data.length === 0 &&
            <>
                { state.isEdit && <AddNew onClick={handleAddEducation}>+ Nieuw opleiding toevoegen</AddNew> }
                { !state.isEdit && <div>Geen resultaten...</div> }
            </>
        }

        <div className={styles['work_experience']}>
            <div className={styles['work_experience-list']}>

            {
                data.map((education: any, idx: number) => {
                    return <>
                        <div className={styles['work_experience-list-item']}>
                            {
                                !state.isEdit && <>
                                    <div className={styles['work_experience-list-item--side']}>
                                        { convertDateToYear(education?.start_date) } - { education?.end_date ? convertDateToYear(education?.end_date) : 'Heden' }
                                    </div>
                                    <div className={styles['work_experience-list-item--content']}>
                                        <div className={styles['work_experience-list-item--content-title']}>
                                            { education?.education_institute }
                                        </div>
                                        <div>
                                            { education?.education }
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                state.isEdit && <>
                                    <div className={styles['work_experience-list-item--side']}>
                                        <div className={styles['work_experience-list-item--side-date']}>
                                            <FormGroup title='Start datum'>
                                                <Field
                                                    type={FieldType.Date}
                                                    value={education?.start_date}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index == idx) ? {...item, start_date: value} : item);
            
                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className={styles['work_experience-list-item--side-date']}>
                                            <FormGroup title='Eind datum'>
                                                <Field
                                                    type={FieldType.Date}
                                                    value={education?.end_date}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index == idx) ? {...item, end_date: value} : item);
                                                        
                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>
                                        
                                        { education.start_date && <>
                                            <div className={styles['work_experience-list-item--side-computed']}>
                                                <strong>Datum: </strong> {`${convertDateToYear(education.start_date)} - ${education.end_date ? convertDateToYear(education.end_date) : 'heden'} ` }
                                            </div>
                                            <div className={styles['work_experience-list-item--side-computed']}>
                                                <strong>Duur: </strong> { calculateTimeDifference(education.start_date, education?.end_date) }
                                            </div>
                                        </> }

                                        <div className={styles['delete']} onClick={() => handleDeleteEducation(idx)}>Opleiding verwijderen</div>
                                    </div>
                                    <div className={styles['work_experience-list-item--content']}>
                                        <div className={styles['work_experience-list-item--content-title']}>
                                            <FormGroup title='Naam opleidinginstituut'>
                                                <Field
                                                    type={FieldType.Text}
                                                    value={education?.education_institute}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index == idx) ? {...item, education_institute: value} : item);
            
                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>
                                        <div>
                                            <FormGroup title='Naam opleiding'>
                                                <Field
                                                    type={FieldType.Text}
                                                    value={education?.education}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index == idx) ? {...item, education: value} : item);
            
                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>
                                        <div>
                                            <FormGroup title='Behaald'>
                                                <Field
                                                    type={FieldType.Toggle}
                                                    value={education?.achieved}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index == idx) ? {...item, achieved: value} : item);
            
                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        {
                            state.isEdit
                            && idx === data.length-1
                            && <AddNew onClick={handleAddEducation}>+ Nieuw opleiding toevoegen</AddNew>
                        }
                    </>;
                })
            }
            </div>
        </div>
    </div>
}

interface Props {
    entity_id: CandidateId
}

const mapState = (state: StoreState, props: Props) => ({
    candidate: getCandidate(state, props.entity_id),
    values: getCandidateValuesFromCandidateId(state, props.entity_id)
});

const mapDispatch = {
    saveCandidateValues,
    createCandidateValues
};

type WorkExperiencesProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(Educations);